'use strict';
import angular from 'angular';
import _ from 'lodash';

import tieredLookupFormHtmlUrl from '../views/tieredLookupForm.html';
import tieredLookupContentFormHtmlUrl from '../views/tieredLookupContentForm.html';

angular.module('tieredLookups.ctrls', [])
    .controller('TieredLookupController', TieredLookupController)
    .controller('TieredLookupContentController', TieredLookupContentController);


TieredLookupController.$inject = ['$rootScope', '$scope', 'TieredLookupsService', 'UserService', 'ClusterService', '$modal', '$ioAlert', '$state', 'filterFilter', 'FormService'];

function TieredLookupController($rs, $scope, TieredLookupsService, UserService, ClusterService, $modal, $ioAlert, $state, filterFilter, FormService) {

    $scope.tieredLookups = [];
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.disableBtnAction = false;

   $scope.getTieredLookups = function() {
        TieredLookupsService.getTieredLookups().then(function(success) {
            var tierTypeData = success.tierTypes;
            for(var i=0; i<tierTypeData.length; i++){
                if(typeof tierTypeData[i].is_tiered_lookup === 'string'){
                    tierTypeData[i].is_tiered_lookup = parseInt(tierTypeData[i].is_tiered_lookup);
                }
                if(typeof tierTypeData[i].id === 'string'){
                    tierTypeData[i].id = parseInt(tierTypeData[i].id);
                }
            }
            $scope.tieredLookups = tierTypeData;
        }, function(error) {
            console.log("error loading tiered lookups");
        });
    };

    // search based on user text
    $scope.updateSearch = function() {
        if ($scope.searchTieredLookups) {
            $scope.filteredTieredLookups = filterFilter($scope.tieredLookups, $scope.searchTieredLookups);
        }
    };

    $scope.addTieredLookup = function(tieredLookup) {
        $scope.isNew = (tieredLookup == null);
        $modal.open({
            controller: function($scope, $modalInstance, tieredLookup, TieredLookupsService, $ioAlert) {
                $scope.lookupObj = {};
                if (tieredLookup) {
                    $scope.lookupObj.name = tieredLookup.name;
                    $scope.titleText = "Update";
                    $scope.lookupObj.isTieredLookup = (tieredLookup.is_tiered_lookup == 1);
                    $scope.lookupObj.defaultValue = tieredLookup.default_value;
                } else {
                    $scope.titleText = "Create New";
                    $scope.lookupObj.isTieredLookup = true;
                    $scope.lookupObj.defaultValue = 0;
                }
                $scope.saveTieredLookup = function(lookupForm) {
                    if (lookupForm.$valid) {
                        var formObj = {
                            "name": $scope.lookupObj.name,
                            "defaultValue": $scope.lookupObj.defaultValue
                        };
                        if ($scope.lookupObj.isTieredLookup == true) {
                            formObj.isTieredLookup = "yes";
                        } else {
                            formObj.isTieredLookup = "no";
                        }
                        if (tieredLookup) {
                            formObj.id = tieredLookup.id;
                            TieredLookupsService.updateTieredLookup(formObj).then(function(response) {
                                if (response.tierType) {
                                    $modalInstance.close(response.tierType);
                                }
                            }, function(error) {
                                console.log("error updating tiered lookup");
                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            });
                        } else {
                            TieredLookupsService.addTieredLookup(formObj).then(function(response) {
                                if (response.tierType) {
                                    $modalInstance.close(response.tierType);
                                }
                            }, function(error) {
                                console.log("error create tiered lookup");
                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            });
                        }
                    }
                };
                $scope.cancel = function() {
                    $modalInstance.dismiss();
                }
            },
            templateUrl: tieredLookupFormHtmlUrl,
            resolve: {
                tieredLookup: function() {
                    return tieredLookup;
                }
            },
            backdrop: 'static'
        }).result.then(function(lookupObj) {
            if ($scope.isNew) {
                $scope.tieredLookups.push(lookupObj);
                $ioAlert.show('New Tiered Lookup', 'New Tiered Lookup has been added successfully', 'success');
            } else {
                for (var i = 0, len = $scope.tieredLookups.length; i < len; i++) {
                    if ($scope.tieredLookups[i].id == lookupObj.id) {
                        $scope.tieredLookups[i] = lookupObj;
                        break;
                    }
                }
                $ioAlert.show('Update Tiered Lookup', 'Tiered Lookup has been updated successfully', 'success');
            }
        }, function(cancel) {

        });
    };

    $scope.deleteTiredLookup = function(tieredLookup) {
        TieredLookupsService.deleteTieredLookup(tieredLookup).then(function(response) {
            if (response.id) {
                for (var i = 0; i < $scope.tieredLookups.length; i++) {
                    if ($scope.tieredLookups[i] && $scope.tieredLookups[i].id == response.id) {
                        $scope.tieredLookups.splice(i, 1);
                        break;
                    }
                }
                $ioAlert.show('Delete Tiered Lookup', 'Tiered Lookup type deleted successfully', 'success');
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.viewTiredLookupContents = function(tieredLookup) {
        $state.go('tieredLookupContents', {
            'tierTypeId': tieredLookup.id
        });
    };

    $scope.gotoLookupTypes = function() {
        $state.go('lookupTypes');
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();

    $scope.init = function() {
        ClusterService.initCluster($rs.userRole, 'hidden');
        $scope.getTieredLookups();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    $scope.init();
}

TieredLookupContentController.$inject = ['$rootScope', '$scope', '$stateParams','UserService', 'TieredLookupsService', 'ClusterService', '$state', '$modal', '$ioAlert', 'ModalService', 'filterFilter', 'FormService'];

function TieredLookupContentController($rs, $scope, $stateParams, UserService, TieredLookupsService, ClusterService, $state, $modal, $ioAlert, ModalService, filterFilter, FormService) {

    $scope.tieredLookupId = $stateParams.tierTypeId;
    $scope.tieredLookupContents = [];
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.disableBtnAction = false;

    $scope.getTieredLookupContents = function() {
        TieredLookupsService.getTieredLookupContents({ tierTypeId: $scope.tieredLookupId }).then(function(response) {
            if (response.tierContents) {
                $scope.tieredLookupContents = response.tierContents;

                //set the ids as numbers and not strings for proper sorting
                if ($scope.tieredLookupContents.length > 0) {
                    for (var i = 0, len = $scope.tieredLookupContents.length; i < len; i++) {
                        $scope.tieredLookupContents[i].id = parseInt($scope.tieredLookupContents[i].id);
                        $scope.tieredLookupContents[i].tier = parseInt($scope.tieredLookupContents[i].tier);
                        $scope.tieredLookupContents[i].sortValue = parseFloat($scope.tieredLookupContents[i].value);
                    }
                }
            }
        }, function(error) {
            console.log("error loading lookup contents for tieredLookup type Id: " + $scope.tieredLookupId);
        });
    };

    $scope.addTieredLookupContent = function(tieredLookupContent) {
        $scope.isNew = (tieredLookupContent == null);
        $modal.open({
            controller: function($scope, $modalInstance, tieredLookupContent, tieredLookupId, TieredLookupsService, $ioAlert) {
                $scope.contentObj = {};
                if (tieredLookupContent) {
                    $scope.contentObj.id = tieredLookupContent.id;
                    $scope.contentObj.tierTypeId = tieredLookupContent.tier_type_id;
                    $scope.contentObj.tier = parseInt(tieredLookupContent.tier);
                    $scope.contentObj.value = parseFloat(tieredLookupContent.value);
                    $scope.titleText = "Update Content";
                } else {
                    $scope.contentObj.tierTypeId = tieredLookupId;
                    $scope.titleText = "Create New Content";
                }
                $scope.saveTieredLookupContent = function(lookupContentForm) {
                    if (lookupContentForm.$valid) {
                        if (tieredLookupContent) {
                            TieredLookupsService.updateTieredLookupContent($scope.contentObj).then(function(response) {
                                if (response.tierContent) {
                                    $modalInstance.close(response.tierContent);
                                }
                            }, function(error) {
                                console.log("error updating tiered lookup");
                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            });
                        } else {
                            TieredLookupsService.addTieredLookupContent($scope.contentObj).then(function(response) {
                                if (response.tierContent) {
                                    $modalInstance.close(response.tierContent);
                                }
                            }, function(error) {
                                console.log("error create tiered lookup");
                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            });
                        }
                    }
                };
                $scope.cancel = function() {
                    $modalInstance.dismiss();
                }
            },
            templateUrl: tieredLookupContentFormHtmlUrl,
            resolve: {
                tieredLookupContent: function() {
                    return tieredLookupContent;
                },
                tieredLookupId: function() {
                    return $scope.tieredLookupId;
                }
            },
            backdrop: 'static'
        }).result.then(function(contentObj) {
            if ($scope.isNew) {
                $scope.tieredLookupContents.push(contentObj);
                $ioAlert.show('New Tiered Lookup', 'New Tiered Lookup has been added successfully', 'success');
            } else {
                for (var i = 0, len = $scope.tieredLookupContents.length; i < len; i++) {
                    if ($scope.tieredLookupContents[i].id == contentObj.id) {
                        $scope.tieredLookupContents[i] = contentObj;
                        break;
                    }
                }
                $ioAlert.show('Update Tiered Lookup', 'Tiered Lookup has been updated successfully', 'success');
            }
        }, function(cancel) {

        });
    };

    // search based on user text
    $scope.updateSearch = function() {
        if ($scope.searchTieredLookupContents) {
            $scope.filteredTieredLookupContents = filterFilter($scope.tieredLookupContents, $scope.searchTieredLookupContents);
        }
    };

    $scope.delTieredLookupContent = function(tieredLookupContent) {
        TieredLookupsService.deleteTieredLookupContent(tieredLookupContent).then(function(response) {
            if (response.id) {
                for (var i = 0; i < $scope.tieredLookupContents.length; i++) {
                    if ($scope.tieredLookupContents[i] && $scope.tieredLookupContents[i].id == response.id) {
                        $scope.tieredLookupContents.splice(i, 1);
                        break;
                    }
                }
                $ioAlert.show('Delete Tiered Lookup Content', 'Tiered Lookup content deleted successfully', 'success');
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    $scope.gotoTieredLookups = function() {
        $state.go('tieredLookups');
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
    $scope.init = function() {
        ClusterService.initCluster($rs.userRole, 'hidden');
        if ($scope.tieredLookupId) {
            $scope.getTieredLookupContents();
        }
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    $scope.init();
}